import { FileUploader, ToastMessage } from '@cokitchen/cokitchen-components';
import MetadataDropdown from 'components/metadata/metadata-dropdown';
import useCreateBlogContext from 'contexts/create-blog.context';
import { MetadataType } from 'pages/create-brand/create-brand-metadata/types';
import { MetadataItemType } from 'pages/metadata/types';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { STORAGE_KEYS } from 'utils/constants';
import { handleApiError } from 'utils/functions';

const CreateBlogImage = () => {
  const { createBlogForm, setCreateBlogForm } = useCreateBlogContext();
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;
  const [keywordsList, setKeywordsList] = useState<MetadataType[]>([]);
  const onKeywordTagClick = (item: MetadataItemType) => {
    const exists = !!createBlogForm.tags.find((k) => k.id === item.id);
    if (!exists) {
      setCreateBlogForm({
        ...createBlogForm,
        tags: [...createBlogForm.tags, item]
      });
    } else {
      const filtered = createBlogForm.tags.filter((w) => w.id !== item.id);
      setCreateBlogForm({ ...createBlogForm, tags: filtered });
    }
  };
  const createMetadata = async (name: string) => {
    const API_URL = 'blog/tags';
    try {
      const res = await apiService.post<MetadataItemType>(API_URL, {
        data: { name }
      });
      if (res.status === 201) {
        const { id } = res.data;
        toast(<ToastMessage type='success' message={'Tag Created'} />);
        setKeywordsList([...keywordsList, { name, id }]);
      }
    } catch {
      toast(<ToastMessage type='error' message='There was a problem adding metadata' />);
    }
  };

  const getKeywordsList = async () => {
    try {
      const res: any = await apiService.get('blog/tags');
      setKeywordsList(res.data);
    } catch (e) {
      handleApiError(e);
    }
  };
  useEffect(() => {
    getKeywordsList();
  }, []);
  return (
    <div>
      <div className='space-y-4'>
        <MetadataDropdown
          title='Tags'
          description='Select keyword'
          metadataList={keywordsList}
          selectedMetadata={createBlogForm.tags}
          onCreate={(w) => createMetadata(w)}
          onTagClick={onKeywordTagClick}
        />
        <div>
          <p className='mb-1 text-sm'>Add Image</p>
          <FileUploader
            key={createBlogForm?.image}
            className='p-0 border-0 mb-8'
            token={token}
            setFileUrls={(urls) => {
              setCreateBlogForm({ ...createBlogForm, image: urls[0] });
            }}
            fileUrls={createBlogForm.image ? [createBlogForm.image] : []}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateBlogImage;
